// Look for all label with data-fieldset="color", and take the inner html and apply a span to it
function colorLabel() {
    var labels = document.querySelectorAll('label[data-fieldset="color"]');

    labels.forEach(function (label) {
        var text = label.innerHTML;
        label.innerHTML = '<span>' + text + '</span>';
    });
}
colorLabel();

document.querySelectorAll('.product .color-swatch').forEach(link => {
    link.addEventListener('click', function (e) {
        e.preventDefault();
        // This replaces current page in history instead of adding new entry
        location.replace(this.href);
    });
});
